import { render, staticRenderFns } from "./DadosPessoais.vue?vue&type=template&id=3e1eff52&scoped=true"
import script from "./DadosPessoais.vue?vue&type=script&lang=js"
export * from "./DadosPessoais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1eff52",
  null
  
)

export default component.exports